/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SendAgentMessageMutationVariables = Types.Exact<{
  input: Types.AgentChatInput;
}>;


export type SendAgentMessageMutation = { sendAgentMessage: { __typename: 'AgentChatTurn', turnId: string, conversationId: string } };

export type StopAgentTurnMutationVariables = Types.Exact<{
  conversationId: Types.Scalars['ID']['input'];
}>;


export type StopAgentTurnMutation = { stopAgentTurn: { __typename: 'AgentStopTurnResult', stopped: boolean } };

export type AgentMessageStreamSubscriptionVariables = Types.Exact<{
  turnId: Types.Scalars['ID']['input'];
}>;


export type AgentMessageStreamSubscription = { agentMessageStream: { __typename: 'AgentChatErrorEvent', seq: number, error: string } | { __typename: 'AgentChatResultEvent', seq: number, messageId?: string | null, reply: string, toolCalls: any, uiActions: any, stopReason?: string | null, model: string, costUsd?: number | null, promptTokens: number, completionTokens: number, tiers: any, escalatedAtIteration?: number | null } | { __typename: 'AgentConversationEvent', seq: number, conversationId: string } | { __typename: 'AgentPingEvent', seq: number } | { __typename: 'AgentTextDeltaEvent', seq: number, delta: string } | { __typename: 'AgentTextDiscardEvent', seq: number } | { __typename: 'AgentToolDoneEvent', seq: number, callId: string, name: string, labelKey?: string | null, input: any, resultPreview: string, durationMs: number, effect: Types.AgentToolEffect, refusalKey?: string | null } | { __typename: 'AgentToolStartEvent', seq: number, callId: string, name: string, labelKey?: string | null, input: any } | { __typename: 'AgentTurnUnavailableEvent', seq: number, reason: string } };

export type AgentConversationHistoryQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type AgentConversationHistoryQuery = { agentConversation?: { __typename: 'AgentConversation', conversationId: string, messages: Array<{ __typename: 'AgentMessage', id: string, role: Types.AgentChatRole, content: string, attachmentNames: Array<string>, toolCalls: any, uiActions: any, model?: string | null, costUsd?: number | null, promptTokens?: number | null, completionTokens?: number | null }> } | { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | null };


export const SendAgentMessageDocument = gql`
    mutation SendAgentMessage($input: AgentChatInput!) {
  sendAgentMessage(input: $input) {
    turnId
    conversationId
  }
}
    `;
export type SendAgentMessageMutationFn = Apollo.MutationFunction<SendAgentMessageMutation, SendAgentMessageMutationVariables>;

/**
 * __useSendAgentMessageMutation__
 *
 * To run a mutation, you first call `useSendAgentMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAgentMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAgentMessageMutation, { data, loading, error }] = useSendAgentMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendAgentMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendAgentMessageMutation, SendAgentMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendAgentMessageMutation, SendAgentMessageMutationVariables>(SendAgentMessageDocument, options);
      }
export type SendAgentMessageMutationHookResult = ReturnType<typeof useSendAgentMessageMutation>;
export type SendAgentMessageMutationResult = Apollo.MutationResult<SendAgentMessageMutation>;
export type SendAgentMessageMutationOptions = Apollo.BaseMutationOptions<SendAgentMessageMutation, SendAgentMessageMutationVariables>;
export const StopAgentTurnDocument = gql`
    mutation StopAgentTurn($conversationId: ID!) {
  stopAgentTurn(conversationId: $conversationId) {
    stopped
  }
}
    `;
export type StopAgentTurnMutationFn = Apollo.MutationFunction<StopAgentTurnMutation, StopAgentTurnMutationVariables>;

/**
 * __useStopAgentTurnMutation__
 *
 * To run a mutation, you first call `useStopAgentTurnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopAgentTurnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopAgentTurnMutation, { data, loading, error }] = useStopAgentTurnMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useStopAgentTurnMutation(baseOptions?: Apollo.MutationHookOptions<StopAgentTurnMutation, StopAgentTurnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopAgentTurnMutation, StopAgentTurnMutationVariables>(StopAgentTurnDocument, options);
      }
export type StopAgentTurnMutationHookResult = ReturnType<typeof useStopAgentTurnMutation>;
export type StopAgentTurnMutationResult = Apollo.MutationResult<StopAgentTurnMutation>;
export type StopAgentTurnMutationOptions = Apollo.BaseMutationOptions<StopAgentTurnMutation, StopAgentTurnMutationVariables>;
export const AgentMessageStreamDocument = gql`
    subscription AgentMessageStream($turnId: ID!) {
  agentMessageStream(turnId: $turnId) {
    __typename
    ... on AgentPingEvent {
      seq
    }
    ... on AgentConversationEvent {
      seq
      conversationId
    }
    ... on AgentToolStartEvent {
      seq
      callId
      name
      labelKey
      input
    }
    ... on AgentToolDoneEvent {
      seq
      callId
      name
      labelKey
      input
      resultPreview
      durationMs
      effect
      refusalKey
    }
    ... on AgentTextDeltaEvent {
      seq
      delta
    }
    ... on AgentTextDiscardEvent {
      seq
    }
    ... on AgentChatResultEvent {
      seq
      messageId
      reply
      toolCalls
      uiActions
      stopReason
      model
      costUsd
      promptTokens
      completionTokens
      tiers
      escalatedAtIteration
    }
    ... on AgentChatErrorEvent {
      seq
      error
    }
    ... on AgentTurnUnavailableEvent {
      seq
      reason
    }
  }
}
    `;

/**
 * __useAgentMessageStreamSubscription__
 *
 * To run a query within a React component, call `useAgentMessageStreamSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAgentMessageStreamSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentMessageStreamSubscription({
 *   variables: {
 *      turnId: // value for 'turnId'
 *   },
 * });
 */
export function useAgentMessageStreamSubscription(baseOptions: Apollo.SubscriptionHookOptions<AgentMessageStreamSubscription, AgentMessageStreamSubscriptionVariables> & ({ variables: AgentMessageStreamSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AgentMessageStreamSubscription, AgentMessageStreamSubscriptionVariables>(AgentMessageStreamDocument, options);
      }
export type AgentMessageStreamSubscriptionHookResult = ReturnType<typeof useAgentMessageStreamSubscription>;
export type AgentMessageStreamSubscriptionResult = Apollo.SubscriptionResult<AgentMessageStreamSubscription>;
export const AgentConversationHistoryDocument = gql`
    query AgentConversationHistory($id: ID!) {
  agentConversation(id: $id) {
    __typename
    ... on AgentConversation {
      conversationId
      messages {
        id
        role
        content
        attachmentNames
        toolCalls
        uiActions
        model
        costUsd
        promptTokens
        completionTokens
      }
    }
  }
}
    `;

/**
 * __useAgentConversationHistoryQuery__
 *
 * To run a query within a React component, call `useAgentConversationHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentConversationHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentConversationHistoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAgentConversationHistoryQuery(baseOptions: Apollo.QueryHookOptions<AgentConversationHistoryQuery, AgentConversationHistoryQueryVariables> & ({ variables: AgentConversationHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentConversationHistoryQuery, AgentConversationHistoryQueryVariables>(AgentConversationHistoryDocument, options);
      }
export function useAgentConversationHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentConversationHistoryQuery, AgentConversationHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentConversationHistoryQuery, AgentConversationHistoryQueryVariables>(AgentConversationHistoryDocument, options);
        }
export function useAgentConversationHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgentConversationHistoryQuery, AgentConversationHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgentConversationHistoryQuery, AgentConversationHistoryQueryVariables>(AgentConversationHistoryDocument, options);
        }
export type AgentConversationHistoryQueryHookResult = ReturnType<typeof useAgentConversationHistoryQuery>;
export type AgentConversationHistoryLazyQueryHookResult = ReturnType<typeof useAgentConversationHistoryLazyQuery>;
export type AgentConversationHistorySuspenseQueryHookResult = ReturnType<typeof useAgentConversationHistorySuspenseQuery>;
export type AgentConversationHistoryQueryResult = Apollo.QueryResult<AgentConversationHistoryQuery, AgentConversationHistoryQueryVariables>;